/**
 * GSC UNIFIED HASHING UTILITY
 * Centralizes crypto logic for audio and data verification.
 */

export async function computeSHA256(buffer: ArrayBuffer): Promise<string> {
    if (!buffer) return "e3b0c44298fc1c149afbf4c8996fb92427ae41e4649b934ca495991b7852b855"; // Empty hash
    const hashBuffer = await crypto.subtle.digest("SHA-256", buffer);
    return Array.from(new Uint8Array(hashBuffer))
        .map(b => b.toString(16).padStart(2, "0"))
        .join("");
}

export async function hashString(input: string): Promise<string> {
    const enc = new TextEncoder();
    const data = enc.encode(input);
    return computeSHA256(data.buffer);
}

// Alias for semantic clarity in audio contexts
export const hashAudio = computeSHA256;
